import { render } from "./humanitySubjectMuseum.vue?vue&type=template&id=71785714&scoped=true"
import script from "./humanitySubjectMuseum.vue?vue&type=script&lang=js"
export * from "./humanitySubjectMuseum.vue?vue&type=script&lang=js"

import "./humanitySubjectMuseum.vue?vue&type=style&index=0&id=71785714&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71785714"]])

export default __exports__